import siteConfig from '@/config';
import PATH_PAGE from '@/router/path';
import { useGetUser } from '@/service/user/hook';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const GlobalAlertInActive = () => {
  const { data: user } = useGetUser({
    staleTime: Infinity,
  });
  if (user?.is_active) return null;
  return (
    <div className="text-warning-foreground flex justify-center gap-2 bg-warning p-1 px-6 text-center">
      <span className="font-bold">Warning:</span>
      <span>Your account is restricted and features are unavailable.</span>
      {siteConfig.services.setting.payment && (
        <Link
          to={PATH_PAGE.setting.payment}
          className="flex items-center gap-1 underline"
        >
          Go to payment settings for more details{' '}
          <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
};

export default GlobalAlertInActive;
